import { render, staticRenderFns } from "./ClientProjectListItem.vue?vue&type=template&id=75391697&"
import script from "./ClientProjectListItem.vue?vue&type=script&lang=js&"
export * from "./ClientProjectListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports